import {
  faStepBackward,
  faStepForward,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "../Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StepDirection } from "../../types/stepDirection";
import { useStep } from "../../hooks/useStep";

interface Props {
  direction: StepDirection;
}

export const StepButton = ({ direction }: Props) => {
  const { stepForward, stepBackward } = useStep();

  const onClick =
    direction === StepDirection.forward ? stepForward : stepBackward;
  const icon =
    direction === StepDirection.forward ? faStepForward : faStepBackward;

  const iconStyle = {
    height: 30,
  };

  return (
    <Button onClick={onClick}>
      <FontAwesomeIcon icon={icon} style={iconStyle} />
    </Button>
  );
};
